import { createContext, useContext, RefObject } from 'react';

interface ChatScrollContextType {
  scrollToBottom: (smooth?: boolean) => void;
  messagesEndRef: RefObject<HTMLDivElement>;
}

const ChatScrollContext = createContext<ChatScrollContextType | null>(null);

export const useChatScrollContext = () => {
  const context = useContext(ChatScrollContext);
  if (!context) {
    throw new Error('useChatScroll must be used within ChatPanel');
  }
  return context;
};

export { ChatScrollContext };
